var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelojDePared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reloj-de-pared",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15500",
    "data-name": "Grupo 15500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15499",
    "data-name": "Grupo 15499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75991",
    "data-name": "Trazado 75991",
    d: "M10.5,0A10.5,10.5,0,1,0,21,10.5,10.512,10.512,0,0,0,10.5,0Zm0,19.467A8.967,8.967,0,1,1,19.467,10.5,8.977,8.977,0,0,1,10.5,19.467Z",
    fill: "#ee2b7b"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15502",
    "data-name": "Grupo 15502",
    transform: "translate(9.223 5.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15501",
    "data-name": "Grupo 15501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_75992",
    "data-name": "Trazado 75992",
    d: "M229.711,130.562H226.39v-4.6a.766.766,0,1,0-1.533,0v5.365a.766.766,0,0,0,.766.766h4.088a.766.766,0,0,0,0-1.533Z",
    transform: "translate(-224.857 -125.197)",
    fill: "#ee2b7b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelojDePared);
export default __webpack_public_path__ + "static/media/reloj-de-pared.a6b2f7568e316cceb65c6177e26f3aef.svg";
export { ForwardRef as ReactComponent };